import { render, staticRenderFns } from "./sysdistribution.vue?vue&type=template&id=0cb4a63a&scoped=true&"
import script from "./sysdistribution.vue?vue&type=script&lang=js&"
export * from "./sysdistribution.vue?vue&type=script&lang=js&"
import style0 from "./sysdistribution.vue?vue&type=style&index=0&id=0cb4a63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4a63a",
  null
  
)

export default component.exports